module.exports = __webpack_public_path__ + "static/27-2673c3af2f6ba54acde1f89d041a0a00.jpg";